<template>
<div class="col-12 row">
  <div class="col-12 faucets">
    <faucets-list-component v-for="(faucet, index) in faucets" :faucet="faucet" :key="faucet.id_faucet" v-on:deleteRow="deleteRow(index)" />
  </div>
  <div class="loader" v-if="load_faucets_list">
    <loader-component />
  </div>
  <div class="col-12 empty-faucets-list-block" v-if="empty_faucets_list">
      <p>У вас нет ни одного крана</p>
  </div>
  <div class="col-12 center-button-block">
    <router-link :to="{ name: 'add-faucet', params: { id_group: id_group }}" class="aquazor-btn">
      Добавить кран
    </router-link>
  </div>
</div>
</template>

<script>
import config from '@/config.js'
import auth from '@/auth.js'
import axios from 'axios'
import {
  store
} from '@/store'
import loader from './elements/loader.vue'
import FaucetRow from './elements/faucet_row.vue'

export default {
  name: 'Faucets',
  created() {
    faucet_list_start(this)
  },
  data() {
    return {
      faucets: [],
      load_faucets_list: false,
      group_name: '',
      faucet_list_status: true,
      page_name: 'faucets',
      id_group: this.$route.params.id_group,
      empty_faucets_list: false
    }
  },
  methods: {
    deleteRow: function (index_row) {
      this.faucets.splice(index_row, 1)
    }
  },
  components: {
    'loader-component': loader,
    'faucets-list-component': FaucetRow
  },
  destroyed() {
    this.faucet_list_status = false
  },
}

function faucet_list_start(vue_obj) {
  if (vue_obj.faucet_list_status) {
    get_faucets_list(vue_obj)
    setTimeout(function () {
      faucet_list_start(vue_obj)
    }, config.UPDATE_PERIOD)
  }
}

function get_faucets_list(vue_obj) {
  if (!!localStorage.token && vue_obj.faucet_list_status) {
    if (vue_obj.faucets.length == 0 && !vue_obj.empty_faucets_list) vue_obj.load_faucets_list = true
    var post_data = new FormData()
    post_data.set('token', localStorage.token)
    post_data.set('id_group', vue_obj.$route.params.id_group)
    axios({
        method: 'POST',
        url: config.API_HOST + '/faucets/list',
        data: post_data
      })
      .then(function (response) {
        vue_obj.load_faucets_list = false
        if (vue_obj.faucets.length == 0) {
          vue_obj.faucets = response.data.faucets
        } else {
          response.data.faucets.forEach(element => {
            let faucet_index = vue_obj.faucets.map(item => item.id_faucet).indexOf(element.id_faucet)
            if (faucet_index >= 0) {
              vue_obj.faucets[faucet_index].position = element.position
              vue_obj.faucets[faucet_index].name = element.name
              vue_obj.faucets[faucet_index].connection = element.connection
              vue_obj.faucets[faucet_index].device_number = element.device_number
              vue_obj.faucets[faucet_index].statuses = element.statuses
            } else {
              vue_obj.faucets.push(element)
            }

          })
          
          vue_obj.faucets.forEach((view_element, index_element) => {
            let faucet_index = response.data.faucets.map(item => item.id_faucet).indexOf(view_element.id_faucet)
            if (faucet_index < 0) {
              vue_obj.deleteRow(index_element)
            }
          })
        }
        if (vue_obj.faucets.length == 0) {
          vue_obj.empty_faucets_list = true
        }
        else {
          vue_obj.empty_faucets_list = false
        }
      })
      .catch(function (error) {

      })
  }
}
</script>

<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/faucets-list.vue